export default __webpack_public_path__ + "static/media/Watt&Volt_ΗΛ.16c10abd.png";